import { Dispatch } from 'redux';
import { SET_SPACE_TITLE_VISIBILITY } from '../../../core/constants/actions';

const setSpaceTitleVisibility =
  (isVisible: boolean) => (dispatch: Dispatch) => {
    dispatch({
      type: SET_SPACE_TITLE_VISIBILITY,
      isVisible,
    });
  };

export default setSpaceTitleVisibility;
